<template>
  <div class="loading-cmp">
    <!-- <CModal
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="userBarcodeModal"
      borderColor="none"
    > -->
      <svg class="spinner_anm" viewBox="0 0 50 50">
        <circle
          class="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke-width="5"
        />
      </svg>
    <!-- </CModal> -->
  </div>
</template>

<script>
export default {
  name: "loading",
  data() {
    return {
      userBarcodeModal: true,
    };
  },

  methods: {},
};
</script>

<style lang="scss">
// .loading-cmp {
//   backdrop-filter: blur(3px);
// }
.overflow-auto{
  backdrop-filter: blur(3px);
  // box-shadow: inset 0 0 0 2000px rgba(141, 141, 141, 0.1);
}
// .modal-content {
// background: none;
// border: none;
//   header,footer {
//     display: none;
//   }

// }
.spinner_anm {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  width: 120px;
  height: 120px;

  .path {
    stroke: #222222;
    stroke-linecap: round;
    -webkit-animation: dash 1.5s ease-in-out infinite;
    animation: dash 1.5s ease-in-out infinite;
  }
}
@-webkit-keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
